import { BasicAsyncEnumerable } from "../BasicAsyncEnumerable.js";
export const take = (source, amount) => {
    async function* iterator() {
        let amountLeft = amount > 0 ? amount : 0;
        for await (const item of source) {
            if (amountLeft-- === 0) {
                break;
            }
            else {
                yield item;
            }
        }
    }
    return new BasicAsyncEnumerable(iterator);
};
